// Generated types for Questionnaire
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from '../../shared/types/scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from '../../shared/types/scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface QuestionnaireReadAPI extends ScopedNodeReadAPI {
}

export interface QuestionnaireWriteAPI extends ScopedNodeWriteAPI {
  questions?: string[];
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const QuestionnaireReadAPISchema: z.ZodType<QuestionnaireReadAPI> = ScopedNodeReadAPISchemaObject.extend({}).passthrough();

export const QuestionnaireWriteAPISchema: z.ZodType<QuestionnaireWriteAPI> = ScopedNodeWriteAPISchemaObject.extend({
  questions: z.array(z.string()).optional(),
}).passthrough();
